
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/og",
      function () {
        return require("private-next-pages/og.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/og"])
      });
    }
  